import Icon from "react-icons-kit";
import { circle } from "react-icons-kit/fa/circle";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";
import React, { Component } from "react";
import { handleTouchClickEvents } from "./TouchService";
import "./index.css";
import { languageService } from "../../Language/language.service";

const Defaults = {
  IconSize: 24,
  TooltipPlacement: "top",
};
/**
 * A reusable component that renders an icon with a tooltip and supports various click and touch events.
 * @param {object} props -
 * @param {object} props.iconGroup - Icon group object that contains various icon props based on the status
 * @param {string} props.status - Status string that is used to select the appropriate icon props from the icon group
 * @param {boolean} [props.toggled] - Boolean value that determines whether the icon is in toggled state or not
 * @param {boolean} [props.disabled] - Boolean value that determines whether the icon is disabled or not
 * @param {boolean} [props.hidden] - Boolean value that determines whether the icon is hidden or not
 * @param {function} [props.onShortPress] - Function to handle short press or click event
 * @param {function} [props.onLongPress] - Function to handle long press event
 * @param {string} [props.className] - Additional class name to apply to the icon container element
 * @param {object} [props.style] - Inline styles to apply to the icon container element
 * @param {boolean} [props.browseFile] - Boolean value that determines whether the icon should be used for browsing a file or not
 * @returns {JSX.Element} - Rendered component
 */

class CustomIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
    this.inputField = null;
    this.handleEventCallback = this.handleEventCallback.bind(this);
    this.onFileSelection = this.onFileSelection.bind(this);
  }

  componentDidMount() {
    this.setState({
      id: `${Math.floor(Math.random() * 100000000)}`,
    });
  }

  onFileSelection(e) {
    let { onShortPress, browseFile } = this.props;
    let { files } = e.target;
    browseFile && files && files.length > 0 && onShortPress && onShortPress(files);
  }
  handleEventCallback = (type, event) => {
    let { onShortPress, onLongPress, browseFile } = this.props;
    switch (type) {
      case "onTouch":
      case "click":
        if (browseFile) {
          this.inputField && this.inputField.click();
        } else {
          onShortPress && onShortPress();
        }
        break;
      case "rightClick":
      case "longPress":
        onLongPress && onLongPress();
        break;

      default:
        break;
    }
  };

  render() {
    let { props } = this;
    let { id } = this.state;
    const { status, iconGroup, className, style, browseFile } = props;
    let iconFound = false;
    let customIconProps = {
      iconProps: { icon: circle },
    };
    if (iconGroup && iconGroup.hasOwnProperty(status)) {
      customIconProps = iconGroup[status];
      iconFound = true;
    }
    let { tooltipPlacement, tooltipTitle, toggledTooltipTitle, toggleIconProps } = customIconProps;
    let iconProps = customIconProps.iconProps;

    let tooltip = tooltipTitle;
    if (props.toggled) {
      toggledTooltipTitle && (tooltip = toggledTooltipTitle);
      toggleIconProps && (iconProps = toggleIconProps);
    }

    let iconId = id ? `icon-id-${id}` : "";
    let fileId = id ? `file-id-${id}` : "";
    return (
      <React.Fragment>
        {!props.hidden && (
          <React.Fragment>
            <span
              data-testid="custom-icon-span"
              className={`custom-icon-default ${className ? className : ""} ${props.toggled && !toggleIconProps ? "toggled" : ""} ${props.disabled ? "disabled" : ""}`}
              id={iconId}
              onClick={(e) => !props.disabled && handleTouchClickEvents(e, this.handleEventCallback)}
              onTouchStart={(e) => !props.disabled && handleTouchClickEvents(e, this.handleEventCallback)}
              onTouchEnd={(e) => !props.disabled && handleTouchClickEvents(e, this.handleEventCallback)}
              onTouchMove={(e) => !props.disabled && handleTouchClickEvents(e, this.handleEventCallback)}
              onContextMenu={(e) =>
                !props.disabled && handleTouchClickEvents(e, this.handleEventCallback)
              } /*onClick={props.onClick && props.onClick}*/
              style={style}
            >
              {iconFound && <Icon {...{ size: Defaults.IconSize, ...iconProps }} />}
            </span>
            {iconId && tooltip ? (
              <UncontrolledTooltip placement={tooltipPlacement ? tooltipPlacement : Defaults.TooltipPlacement} target={iconId}>
                {languageService(tooltip)}
              </UncontrolledTooltip>
            ) : null}
            {browseFile ? (
              <input
                onChange={this.onFileSelection}
                ref={(input) => (this.inputField = input)}
                type="file"
                id={fileId}
                name={`file-name-${id}`}
                style={{ visibility: "hidden", height: 0, width: 0, position: "absolute" }}
              />
            ) : null}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
CustomIcon.propTypes = {
  iconGroup: PropTypes.shape({
    // shape of the icon group
    [PropTypes.string.isRequired]: PropTypes.shape({
      iconProps: PropTypes.shape({
        icon: PropTypes.object.isRequired,
      }).isRequired,
      tooltipTitle: PropTypes.string.isRequired,
      toggledTooltipTitle: PropTypes.string,
      tooltipPlacement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
      toggleIconProps: PropTypes.shape({
        icon: PropTypes.object.isRequired,
        // additional props for the toggle icon
      }),
    }),
  }),
  status: PropTypes.string,
  toggled: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  onShortPress: PropTypes.func,
  onLongPress: PropTypes.func,
  browseFile: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default CustomIcon;



// WEBPACK FOOTER //
// ./src/libraries/CustomIcon/index.jsx